import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import {
  TIPO_DE_DECLARACAO,
} from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    TIPO_DE_DECLARACAO
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    TIPO_DE_DECLARACAO,
    id,
  ]);
}

export async function register(data, queryParams = []) {
  return doPostQCXRequest(
    [TIPO_DE_DECLARACAO],
    data,
    queryParams
  );
}

export async function save(data, queryParams = []) {
  return doPutQCXRequest(
    [TIPO_DE_DECLARACAO],
    data,
    queryParams
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [TIPO_DE_DECLARACAO],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [TIPO_DE_DECLARACAO],
    id
  );
}
